import React, { useCallback, useContext } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import {
	CreateStudioContext,
	ICreateStudioContext,
} from '../createStudioModalContext/createStudioModalState/createStudioModalContext';
import { EditVideoContext, IEditVideoContext } from '../../../../editVideoState/editVideoContext';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { convertUndefinedFields } from 'utils/helpers';
import { createVideoStudio } from 'backend/videos';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { resetFields, changeTypeOfModalWindow, dataForSubmit, typeOfModalWindow } =
		useContext<ICreateStudioContext>(CreateStudioContext);
	const { changeTypeOfModalWindow: changeTypeOfEditVideoModalWindow, refetchStudios } =
		useContext<IEditVideoContext>(EditVideoContext);
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const handleReset = useCallback(() => {
		resetFields();
		changeTypeOfModalWindow(null);
		changeTypeOfEditVideoModalWindow(null);
	}, []);

	const handleConfirm = useCallback(async () => {
		if (dataForSubmit) {
			try {
				const convertedData = convertUndefinedFields(dataForSubmit);
				showLoader();
				await createVideoStudio(convertedData);
				changeTypeOfModalWindow('success');
				// Update data in studios select
				refetchStudios(true);
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	}, [dataForSubmit]);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, []);

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalToConfirm
				onConsentEvent={handleReset}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmFieldsClearing'}
				description="cancelSaveInfo"
			/>
			<ModalToConfirm
				onConsentEvent={handleConfirm}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmSubmit'}
				description="saveInfo"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleReset}
				isVisible={typeOfModalWindow === 'success'}
				description="savedSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSaving"
			/>
		</div>
	);
};

export default React.memo(ModalWindows);
